export default __webpack_public_path__ + "static/media/profile.13d36679.jpeg";